// Section for import npm components -----------------------------------------------------------------------------------
import React, { useContext } from 'react';

// Material UI ( mui ) components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
// Section for import custom components --------------------------------------------------------------------------------
import { AppConfigContext } from '@providers/AppConfigProvider';

// Section for render component ----------------------------------------------------------------------------------------

// Section for type definition -----------------------------------------------------------------------------------------

export default function ConsultationMansion() {
  const { comUrl } = useContext(AppConfigContext);

  return (
    <Box className="mb-16 max-md:mb-12 pt-16 max-md:pt-12 max-md：pt-12 pb-10 max-md:pb-4 bg-gray-01">
      <Box className="max-w-[613px] mx-auto">
        <Typography variant="h2" className="mb-6 text-center font-bold text-2xl text-rf-black">
          気になるマンションを相談
        </Typography>
        <Box className="flex md:gap-x-14 max-md:flex-col max-md:gap-y-8">
          <Box className="max-md:mx-auto">
            <img
              src="https://assets.renovefudosan.com/production/karte/assets/images/detail/common/consultation_cta.png"
              alt="気になるマンションを相談"
              className="w-[237px] max-md:w-[250px] h-[256px] max-md:h-[270px]"
              width={237}
              height={256}
            />
          </Box>
          <Box className="flex flex-col justify-end gap-y-2 pb-8  max-md:mx-5">
            <Box className="text-center">
              <Typography
                component="span"
                className="relative text-base text-rf-navy font-bold
            after:absolute after:top-[21px] after:left-[-40px] after:bottom-[8px] after:bg-rf-navy after:transform after:rotate-[50deg] after:w-[36px] after:h-[1px] after:rounded-sm
            before:absolute before:top-[21px] before:right-[-90px] before:bottom-[8px] before:bg-rf-navy before:transform before:-rotate-[50deg] before:w-[36px] before:h-[1px] before:rounded-sm"
              >
                ワンストップリノベーション
                <br />
                店舗数No.1<span className="text-[8px]">※</span>
              </Typography>
            </Box>
            <Link href={`${comUrl}lp/inquiry_check/`} className="group relative" underline="none">
              <Typography className="rf-btn-lg-spMax text-sm font-bold text-rf-black flex items-center justify-center">
                リノベ不動産に無料相談
              </Typography>
              <img
                src="https://assets.renovefudosan.com/production/karte/assets/images/common/ArrowForwardRoundedIcon_black.svg"
                alt="arrow"
                className="md:opacity-0 md:group-hover:opacity-100 absolute top-[18px] right-[20px] w-5 transition-opacity duration-150"
              />
            </Link>
            <Typography className="mt-2 text-[10px] leading-[12px] text-center">
              ※ 株式会社wakuwaku調べ（2025年1月時点）
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
